import DropDownWithDetails from "./DropDownWithDetails";
export default DropDownWithDetails;
